export const newYearMixin = {
  computed: {
    showNewYearDesign: function () {
      const today = new Date()
      const month = today.getMonth() + 1 // Январь = 0
      const day = today.getDate()

      return (month === 12 && day >= 15) || (month === 1 && day <= 15)
    },
    showNewYearTimer () {
      const today = new Date()
      const month = today.getMonth() + 1 // Январь = 0
      const day = today.getDate()

      return (month === 12 && day >= 5)
    }
  }
}
